var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 5045"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 4h4v4H7zM13 4h4v4h-4zM7 10h4v4H7zM13 10h4v4h-4zM7 16h4v4H7zM13 16h4v4h-4z",
    "data-name": "Rectangle 5044"
  }))));
};
export default SvgDragHandle;